import React from 'react';
import { connect } from 'react-redux';
import { Form, Grid } from 'semantic-ui-react';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import { PropTypes } from 'prop-types';

import { TitledCard } from 'Components/';
import {
  CheckboxField,
  InputField,
  ButtonGroupField,
} from 'Common/SemanticWrapper';
import { POWERSCHOOL_EXPORT_CONFIGURATION_FORM_NAME } from 'Common/FormEnum';
import { PowerSchoolExportFieldEnum as FieldEnum } from 'Common/Constants/SISIntegration';
import { SchedulerField } from 'Common/ReduxFormFields';

import { ExportFieldsOptions } from '../../helpers/PowerSchoolExportHelpers';

const PowerSchoolExportConfigurationFormContainer = ({
  disabled,
  exportEnabled,
}) => {
  return (
    <Form name={POWERSCHOOL_EXPORT_CONFIGURATION_FORM_NAME}>
      <TitledCard title="Configuration">
        <Grid>
          <Grid.Row>
            <Grid.Column width={6}>
              <Field
                label="File Name"
                component={InputField}
                name={FieldEnum.FTPFileName}
                disabled={disabled}
              />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column width={6}>
              <Field
                label="Enable PowerSchool Nightly Export"
                name={FieldEnum.ExportEnabled}
                component={CheckboxField}
                infoMessage="You must run a manual export before the auto exports will run."
                disabled={disabled}
              />
            </Grid.Column>
          </Grid.Row>

          {exportEnabled && (
            <Grid.Row>
              <Grid.Column width={6}>
                <Field
                  label="Export Time"
                  component={SchedulerField}
                  name={FieldEnum.ExportTime}
                  showDays={false}
                  disabled={disabled}
                />
              </Grid.Column>
            </Grid.Row>
          )}
        </Grid>
      </TitledCard>

      <TitledCard title="Field Mapping">
        <Grid>
          <Grid.Row>
            <Grid.Column width={6}>
              <Field
                label="File Contains"
                component={ButtonGroupField}
                name={FieldEnum.ExportFields}
                options={ExportFieldsOptions}
                disabled={disabled}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </TitledCard>
    </Form>
  );
};

PowerSchoolExportConfigurationFormContainer.propTypes = {
  disabled: PropTypes.bool,
};

const validate = (values) => {
  const errors = {};

  if (!values[FieldEnum.FTPFileName]) {
    errors[FieldEnum.FTPFileName] = 'File name is required';
  }

  return errors;
};

export const PowerSchoolExportConfigurationFormForm = reduxForm({
  form: POWERSCHOOL_EXPORT_CONFIGURATION_FORM_NAME,
  validate,
  enableReinitialize: true,
})(PowerSchoolExportConfigurationFormContainer);

const mapStateToProps = (state) => {
  const selector = formValueSelector(
    POWERSCHOOL_EXPORT_CONFIGURATION_FORM_NAME
  );

  return {
    //https://github.com/redux-form/redux-form/issues/2253
    //https://github.com/redux-form/redux-form/issues/4344
    exportEnabled: selector(state, [FieldEnum.ExportEnabled]),
  };
};

export const PowerSchoolExportConfigurationForm = connect(
  mapStateToProps,
  null
)(PowerSchoolExportConfigurationFormForm);



// WEBPACK FOOTER //
// ./src/pages/powerschoolintegration/powerschoolexport/components/PowerSchoolExportConfigurationStep/PowerSchoolExportConfigurationForm.js